import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const AdminPreviewDataContext = createContext(null);

export function AdminPreviewDataProvider({ value, children }) {
  return (
    <AdminPreviewDataContext.Provider value={value}>
      {children}
    </AdminPreviewDataContext.Provider>
  );
}

AdminPreviewDataProvider.propTypes = {
  value: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export function useAdminPreviewDataOverride() {
  return useContext(AdminPreviewDataContext);
}
